import { render, staticRenderFns } from "./300433-member-profile-extras.vue?vue&type=template&id=3be8c85c&scoped=true"
import script from "./300433-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./300433-member-profile-extras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8c85c",
  null
  
)

export default component.exports